"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerReviews = void 0;
const react_1 = __importDefault(require("react"));
const review_stars_1 = require("../review-stars");
const text_1 = require("../text/");
const styles_1 = require("./styles");
const CustomerReviews = (props) => {
    const { averageOverallRating = '0', totalRatingCount = '0', reviewHref, reviewsFontSize } = props;
    const parsedNumReviews = parseInt(totalRatingCount);
    const parsedIntLocaleString = isNaN(parsedNumReviews) ? '0' : parseInt(totalRatingCount).toLocaleString();
    return (react_1.default.createElement(styles_1.Reviews, { href: reviewHref },
        react_1.default.createElement(styles_1.StarBox, { margin: "0 2px 0 0" },
            react_1.default.createElement(review_stars_1.Stars, { numStars: parseFloat(averageOverallRating) })),
        react_1.default.createElement(text_1.Text, { color: "#007185", "data-cy": 'average-customer-reviews', fontSize: reviewsFontSize },
            "\u00A0",
            parsedIntLocaleString)));
};
exports.CustomerReviews = CustomerReviews;
__exportStar(require("./types"), exports);
